var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBookLocal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 4,
    fill: "#3E71A9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.235 18c0 8.985-7.883 14.024-9.813 15.126a.854.854 0 01-.845 0C17.647 32.025 9.765 26.985 9.765 18a10.235 10.235 0 0120.47 0z",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.932,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.446 18.746L20 13.374l-6.446 5.372M18.506 19.352h2.988v4.3h-2.988z",
    stroke: "#3E71A9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.415 17.503v4.906c0 .687.556 1.243 1.242 1.243h6.686c.686 0 1.242-.556 1.242-1.243v-4.906",
    stroke: "#3E71A9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default SvgBookLocal;